var heading_default = {
  "fontElementMap": "c9Usw",
  "elementSpacing": "aDjTG",
  "headerOne": "z6Fp6 aDjTG",
  "headerTwo": "Nujkk aDjTG",
  "headerThree": "VvJY9 aDjTG",
  "headerFour": "_7VwFL aDjTG",
  "headerFive": "AcqdX aDjTG",
  "headerSix": "c-AzU aDjTG",
  "child": "mHxYK"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
